import { CommonStyledSelectMenuProps } from "@/components/utils/SelectStyles";
import { VirtualDataRoomPermissionType } from "@/models/virtual-data-room/VirtualDataroomPermissionType";
import { EnumsUtils } from "@/utils/TaskEnumUtils";
import { MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { CommonStyledSelect } from "../DataRoomDirectoryFileTree";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  defaultPermission: VirtualDataRoomPermissionType;
  onChange: (p: VirtualDataRoomPermissionType) => void;
}

export const GuestPopoverPermission = (props: Props) => {
  const [isSelectOpen, setIsSelectOpen] = useState(props.open);

  useEffect(() => {
    setIsSelectOpen(props.open);
  }, [props.open]);

  const handleSelectClose = () => {
    setIsSelectOpen(false);
    props.setOpen(false);
  };

  const handleSelectOpen = () => {
    setIsSelectOpen(true);
  };

  return (
    <>
      <CommonStyledSelect
        open={isSelectOpen}
        onOpen={handleSelectOpen}
        onClose={handleSelectClose}
        MenuProps={CommonStyledSelectMenuProps}
        sx={{
          "&& .MuiSelect-select": {
            padding: 0,
            paddingRight: "2rem",
          },
        }}
        defaultValue={props.defaultPermission || VirtualDataRoomPermissionType.CAN_VIEW}
        onChange={(ev) => props.onChange(ev.target.value as VirtualDataRoomPermissionType)}
      >
        {Object.keys(VirtualDataRoomPermissionType).map((k) => {
          if (k === VirtualDataRoomPermissionType.CAN_EDIT) return null;
          return (
            <MenuItem key={k} value={VirtualDataRoomPermissionType[k]}>
              {EnumsUtils.parseEnumToRender(VirtualDataRoomPermissionType[k])}
            </MenuItem>
          );
        })}
      </CommonStyledSelect>
    </>
  );
};
